export {default} from './RankProgress.connect';
